import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,

    
}
const mutations={
   
    getExpressPriceIndex(state,value){
        
        
       
        post(urls.admin.express_price.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
           
        });
        
    },
    editExpressPrice(state,value){



        post(urls.admin.express_price.edit,value).then((result)=>{



            state.result=result




        });

    },



  

 

}
const  actions={


    getExpressPriceIndexAction(context,value){
       
        context.commit("getExpressPriceIndex",value)
       
    },
    editExpressPriceAction(context,value){

        context.commit("editExpressPrice",value)

    },
  
  

    

}

export default {state,mutations,actions}